export default function megaMenu() {
  const megaMenuButton = document.getElementById('js-megaMenuButton');
  const megaMenu = document.getElementById('js-megaMenu');

  megaMenuButton.addEventListener('mouseenter', function () {
    megaMenu.classList.add('is-active');
  })

  megaMenuButton.addEventListener('mouseleave', function () {
    megaMenu.classList.remove('is-active');
  });

  megaMenu.addEventListener('mouseleave', function () {
    megaMenu.classList.remove('is-active');
  });

  const megaMenuButton2 = document.getElementById('js-megaMenuButton_2');
  const megaMenu2 = document.getElementById('js-megaMenu_2');

  megaMenuButton2.addEventListener('mouseenter', function () {
    megaMenu2.classList.add('is-active');
  })

  megaMenuButton2.addEventListener('mouseleave', function () {
    megaMenu2.classList.remove('is-active');
  });

  megaMenu.addEventListener('mouseleave', function () {
    megaMenu2.classList.remove('is-active');
  });
}
